<script>
	import Comment from "./Comment.svelte";

	export let item;
	export let returnTo;

	$: url = !item.domain ? `https://news.ycombinator.com/${item.url}` : item.url;
</script>

<style>
	article {
		margin: 0 0 1em 0;
	}

	a {
		display: block;
		margin: 0 0 1em 0;
	}


	

	
	h1{
		font-family:"opendyslexic3-bold";
		color: #0098C6;
		}
		
			
		h1 a {
			color: #0098C6;
		}
		
		
		h2{
		font-family:"opendyslexic3-bold";
		color:#34B16F;
		font-size:18px;	
			
		}
		
		footer a {
			color:#34B16F;
		}
	
	container {
		display: flex;
		justify-content: space-beteen;
	}
back {
	font-size:30px;
	
}

</style>

<container>
	<h1> <a href="/"> 📰Neu.sh </a></h1> 
	<h2>HN Clone with Open Dyslexic Font </h2>
	</container>
	
	<back>
<a href={returnTo}>🔙 </a>

</back>
<article>
<a href="{url}">
	<h1>{item.title} </h1>
	{#if item.domain}
		<small>{item.domain}</small>
	{/if}
</a>

	<p class="meta">submitted by {item.user} {item.time_ago}
</article>

<div class="comments">
	{#each item.comments as comment}
		<Comment {comment}/>
	{/each}
</div>
<br>
<footer>
	<a href="https://david.dev"> made with 💙 by David.Dev </a> 
	</footer>
